import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { AuditHistoryList } from './AuditHistoryList'
import { AuditHistoryDetail } from './AuditHistoryDetail'

interface AuditHistoryDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Dialog that hosts the audit history feature. Two views internally:
 *   - List of recent snapshots (default)
 *   - Detail view (click on an item) — shows before/after KPIs + per-field diffs
 *
 * Lives at the top-level of the gerencial page; opened by the "Histórico"
 * button in the TopBar.
 */
export function AuditHistoryDialog({ open, onOpenChange }: AuditHistoryDialogProps) {
  const [selectedId, setSelectedId] = useState<string | null>(null)

  // Reset selection when dialog closes — opening it next time starts on the list.
  const handleOpenChange = (next: boolean) => {
    if (!next) setSelectedId(null)
    onOpenChange(next)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="bg-brand-dark border-brand-dark-lighter sm:max-w-6xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-white text-lg font-display">
            {selectedId ? 'Detalhes da auditoria' : 'Histórico de auditoria'}
          </DialogTitle>
          <p className="text-xs text-brand-gray font-body">
            {selectedId
              ? 'Comparativo da DRE antes e depois da operação'
              : 'Snapshots da DRE capturados em cada importação ou edição em lote'}
          </p>
        </DialogHeader>

        <div className="py-2">
          {selectedId ? (
            <AuditHistoryDetail
              id={selectedId}
              onBack={() => setSelectedId(null)}
            />
          ) : (
            <AuditHistoryList onSelect={setSelectedId} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
